import React, { Component } from "react";
import FormInputs from "../../components/UI/FormInputs";
import Buttons from "../../components/UI/Buttons";
import TableGrid from "../../components/UI/TableGrid";
import CompanyService from "../../services/CompanyService";
import { convertUnderScoreStrings, isObject, isSet, toQueryString } from "../../utils/commonUtils";
import WithRoutify from "../../hoc/WithRoutify";
import { OK } from "../../utils/constant";
import withReduxState from "../../hoc/wReduxState";
import WithRouter from "../../hoc/WithRouter";
import TableSkeleton from "../../hoc/TableSkeleton";
import PERMISSIONS from "../../utils/AclPermissions";
import AddVideoConfig from "./AddVideoConfig";
import Icd10Service from "../../services/Icd10Service";
import VideoPlayer from "./VideoPlayer";
import VideoConfigService from "../../services/VideoConfigService";

class VideoConfigList extends Component {
  state = {
    importModalOpen: false,
    importType: ''
  };

  importModalHandler = (type) => {
    this.setState({
      importModalOpen: !this.state.importModalOpen, // toggle open/close
      importType: type
    });
  };
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxchangeHandler,
      },
      {
        label: "Screen",
        key: "screen_route",
        type: "",
        inputType: "TextInput",
        sortName: "screen_route",
      },
       {
        label: "Video Link",
        key: "video_url",
        type: "",
        inputType: "TextInput",
      },
      {
        label: "Description",
        key: "description",
        type: "",
        inputType: "TextInput",
      },
     
      { label: "Action", key: "action", type: "Actions" },
      //  more columns as needed
    ];
    this.state = {
      filters: {
        search_query: "",
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 200,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "screen_route",
          sort_order: "asc",
          search: {},
        },
      },
      formDataInEdit: {},
      activeEditId: null,
      organizationOption: [],
      clinicOptions: [],
      // Your state variables go here
      isModelOpen: false,
      organization_id: "",
    };
  }

  componentDidMount() {
    // let userProfile

    // const fetchList = async () => {
    //   await this.fetchIcdList();
    // };
    // fetchList();
    this.fetchList()
    // Code to run after the component has mounted
  }

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('logs',this.props);
    // Code to run after the component has updated
  };

  componentWillUnmount() {
    // Code to run before the component is unmounted
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addFormHandler = () => {
    this.setState({ isModelOpen: !this.state.isModelOpen });
  };

  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val,
      },
    });
  };
  render() {
    const { tableRecords, filters, isModelOpen, activeEditId ,importModalOpen} = this.state;
    return (
      <>
        {isModelOpen ? (
          // <VideoPlayer />
          <AddVideoConfig
            modelTitle={`${this.state.activeEditId ? "Update" : "Add"} Tutorial Video`}
            isOpen={this.state.isModelOpen}
            fetchList={this.fetchList}
            addFormHandler={this.addFormHandler}
            activeEditId={activeEditId}
          />
        ) : (
          <></>
        )}

        <TableSkeleton
          tableRecords={tableRecords}
          addFormHandler={this.addFormHandler}
          acl={PERMISSIONS.TUTORIAL_VIDEO.CREATE}
          content={"Tutorial Video"}
        >
          <div className="sh_cardBox sh_cardbglight">
            <div className="sh_cardHeader">
              <div className="form-group d-flex mb-0 justify-content-between align-items-center formheader">
                <h6 class="text-lg f-500 mb-0">Tutorial Video-configure List </h6>
                <div className="d-flex">
                  <div className="form-group-fields row mr-2">
                    <div className="col-12 px-1 d-flex">
                      <div className="input-group input-group-joined input-group-solid">
                        <FormInputs
                          placeholder="Search"
                          value={filters["search_query"]}
                          changeHandler={(val) =>
                            this.onChangeFiltersHandler("search_query", val)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="btn-group pl-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => this.submitFiltersHandler()}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => this.clearFiltersHandler()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="addAction">
                    <div className="btn-group">
                      <Buttons
                        clickHandler={() => {
                          this.addFormHandler();
                          this.setState({ activeEditId: "" });
                        }}
                        className="btn btn-primary"
                        acl={PERMISSIONS.TUTORIAL_VIDEO.CREATE}
                        label={"Add"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sh_cardBody p-0">
              <TableGrid
                addFormHandler={() => this.addFormHandler()}
                hasPagination={true}
                fetchTableRecords={(filters) => this.fetchList(filters)}
                {...tableRecords}
              />
            </div>
          </div>
        </TableSkeleton>
      </>
    );
  }
  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      search: filters,
    };
    this.fetchList(queryfilters);
  };
  clearFiltersHandler = async () => {
    await this.setState({
      filters: {},
    });
    this.submitFiltersHandler();
  };
  fetchList = async (query = {}) => {
    const { tableRecords } = this.state;
    try {
      const queryString = toQueryString({
        ...tableRecords.pagination,
        ...query,
      });
      this.props.Loader(true);
      const response = await VideoConfigService.getVideoConfigList(queryString);
      console.log("response", response);

      const tableData = response?.data.data.map((data, companyIndex) => ({
        companyIndex: companyIndex,
        isHeading: false,
        rowId: data.tutorial_id,
        data: {
          isActive: false,
          screen_route: data.screen_route,
          description: data.description,
          video_url: convertUnderScoreStrings(data.video_url),
          active: "Yes",
          action: [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              title: "View",
              type: "GridEdit",
              acl: PERMISSIONS.TUTORIAL_VIDEO.EDIT,
              clickHandler: (rowId, data) => this.editHandler(rowId, data),
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Remove",
              acl: PERMISSIONS.TUTORIAL_VIDEO.DELETE,
              title: "Delete",
              isDelete: true,
              clickHandler: () => this.deleteHandler(data.tutorial_id),
            },
          ],
        },
      }));
      // console.log('tableData',response?.data);
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: prevState.tableRecords.tableHeaders,
          tableRows: {
            type: "default",
            status: 200,
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: response?.data?.total,
          },
        },
      }));
    } catch (err) {
      this.setState({
        tableRecords: {
          ...tableRecords,
          tableRows: {
            ...tableRecords.tableRows,
            status: 200,
          },
        },
      });
      console.log("DataIsse");
      // console.error("Error fetching companies:", err);
    } finally {
      this.props.Loader(false);
    }
  };

  deleteHandler = async (id) => {
    this.props.Loader(true);
    VideoConfigService.deleteVideoConfig(id)
      .then((res) => {
        this.fetchList();
        this.props.Toast.success("Tutorial video Deleted Succesfully");
      })
      .catch((err) => {
        //
      })
      .finally(() => {
        //
        this.props.Loader(false);
      });
  };
  editHandler = (rowId, data) => {
    this.setState(
      {
        activeEditId: rowId,
      },
      this.addFormHandler()
    );
  };

  checkBoxchangeHandler = (value, e, rowId) => {
    const { tableRows } = this.state.tableRecords;

    const updatedData = tableRows.data.map((item) => {
      if (item.rowId === rowId) {
        item.data.isActive = value;
      }
      return item;
    });

    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          ...prevState.tableRecords.tableRows,
          data: updatedData,
        },
      },
    }));
  };
}
export default WithRouter(withReduxState(WithRoutify(VideoConfigList)));
